export default {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    children: [
        {
            path: '',
            component: () => import('@/views/login/login.vue'),
        },
        {
            path: "register",
            component: () => import('@/views/login/register.vue'),
            // component: register,
        },
        {
            path: 'forgetPassword',
            component: () => import('@/views/login/forgetPassword'),
        },
    ]
}